import { render } from "./NewOnCallPage.vue?vue&type=template&id=e0b4f0c0"
import script from "./NewOnCallPage.vue?vue&type=script&lang=js"
export * from "./NewOnCallPage.vue?vue&type=script&lang=js"

import "./NewOnCallPage.vue?vue&type=style&index=0&id=e0b4f0c0&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__